import { gql } from "apollo-boost";

export const GET_CUPS_YEAR = gql`
  query {
    cups {
      year
    }
  }
`;

export const GET_MATCH_BY_ROUND_PER_YEAR = gql`
  query matchesByRoundWhereYear(
    $where: CupWhere
    $options: CupOptions
    $containsGamesGamesOptions2: GameOptions
  ) {
    cups(where: $where, options: $options) {
      year
      matches
      hostedByHosts {
        name
      }
      containsGamesGames(options: $containsGamesGamesOptions2) {
        id
        score
        date
        home_score
        away_score
        attendance
        away_captain
        home_captain
        away_manager
        home_manager
        referee
        notes
        officials
        away_goal
        home_goal
        playedInStadiums {
          name
        }
        awayTeamCountries {
          team
        }
        homeTeamCountries {
          team
        }
        inPhaseRounds {
          name
        }
      }
    }
  }
`;

export const GET_CUPS = gql`
  query Cups {
    cups {
      champion
      attendance
      matches
      teams
      runner_up
      year
      top_scorrer
      hostedByHosts {
        name
      }
    }
  }
`;

export const GET_ALL_CUP_MATCHES = gql`
  query allCupMatches {
    cups {
      year
      matches
      hostedByHosts {
        name
      }
      containsGamesGames {
        id
        score
        date
        home_score
        away_score
        attendance
        away_captain
        home_captain
        away_manager
        home_manager
        notes
        referee
        officials
        away_goal
        home_goal
        away_penalty
        home_penalty

        playedInStadiums {
          name
        }
        awayTeamCountries {
          team
        }
        homeTeamCountries {
          team
        }
        inPhaseRounds {
          name
        }
      }
    }
  }
`;

export const GET_ALL_COUNTRIES_WITH_CUP_STATS = gql`
  query GamesTeamAggregate {
    countries {
      team
      isHostHostsAggregate {
        count
      }
      gamesAwayTeamAggregate {
        count
      }
      gamesHomeTeamAggregate {
        count
      }
    }
  }
`;

export const GET_ALL_COUNTRIES_WITH_CUP_STATS_WITH_MATCHES = gql`
  query GamesTeamWithMatchesAggregate {
    countries {
      team
      isHostHostsAggregate {
        count
      }
      gamesAwayTeamAggregate {
        count
      }
      gamesHomeTeamAggregate {
        count
      }
      gamesAwayTeam {
        date
        homeTeamCountries {
          team
        }
      }
      gamesHomeTeam {
        date
        awayTeamCountries {
          team
        }
      }
    }
  }
`;

export const GET_COUNTRY_MATCHES = gql`
  query Countries($countriesWhere: CountryWhere) {
    countries(where: $countriesWhere) {
      team
      gamesHomeTeam(options: { sort: [{ date: DESC }] }) {
        date
        score
        away_score
        home_score
        inPhaseRounds {
          name
        }
        awayTeamCountries {
          team
        }
        homeTeamCountries {
          team
        }
      }
      gamesAwayTeam(options: { sort: [{ date: DESC }] }) {
        date
        score
        away_score
        home_score
        inPhaseRounds {
          name
        }
        awayTeamCountries {
          team
        }
        homeTeamCountries {
          team
        }
      }
    }
  }
`;

export const GET_COUNTRIES_NAME = gql`
  query Countries($options: CountryOptions) {
    countries(options: $options) {
      team
    }
  }
`;

export const GET_TEN_BEST_ATTENDANCE = gql`
  query TenBestAttendance($limit: Int = 10, $attendance: SortDirection = DESC) {
    cups(options: { sort: { attendance: $attendance }, limit: $limit }) {
      year
      attendance
    }
  }
`;

export const GET_NO_CUP_PER_COUNTRY = gql`
  query CupsAggregate($champion: CupWhere) {
    cupsAggregate(where: $where) {
      count
    }
  }
`;

export const GET_ALL_CHAMPIONS = gql`
  query CupsAggregate {
    cups(options: { sort: [{ champion: ASC }] }) {
      champion
    }
  }
`;
